/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Run_Subject_FileInputs */



/**
* | output |
* | --- |
* | "An uploaded file" |
*
* @param {Leveling_Run_Subject_FileInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_run_subject_file = /** @type {((inputs?: Leveling_Run_Subject_FileInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Run_Subject_FileInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загруженный файл")
	return /** @type {LocalizedString} */ ("An uploaded file")
});